export default __webpack_public_path__ + "static/media/BackIcon.e41d7e2b.svg";